import { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  register?: any;
  errors?: any;
  required?: boolean;
  pattern?: any;
  validate?: any;
  leftIcon?: React.ReactNode;
}

const   TextInput = (props: Props) => {
  const { label, name, register, required, errors, pattern, validate, leftIcon, ...rest } = props;
  const error = errors ? errors[name] : null;

  return (
    <div className="relative w-full">
      <div className="relative">
        {leftIcon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">{leftIcon}</div>
        )}
        <input
          {...register(name, { required, pattern, validate })}
          {...rest}
          placeholder={label}
          className={`block w-full text-base appearance-none focus:outline-none bg-transparent ${
            leftIcon ? 'pl-12' : 'pl-4'
          } pr-4 py-4 border border-blue-300 rounded-md placeholder-gray-500`}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
    </div>
  );
};

export default TextInput;
